import {
  changeAssigned,
  editProfilePencil,
  giftIcon,
  interactionIcon,
  moveCard,
  trashcanIcon,
} from '@/assets/images';
import MultiActionDialogKey from '@/constants/MultiActionDialogKey';
import translate from '@/lib/intl/translate';

const { INTERACTION, DONATION, MOVE, ASSIGN, EDIT, REMOVE } =
  MultiActionDialogKey;

const DONOR_ACTION_CONFIG = [
  {
    key: INTERACTION,
    icon: interactionIcon,
    text: translate('DONOR_BOARD_ACTION_INTERACTION'),
  },
  {
    key: DONATION,
    icon: giftIcon,
    text: translate('DONOR_BOARD_ACTION_CONTRIBUTION'),
  },
  {
    key: MOVE,
    icon: moveCard,
    text: translate('DONOR_BOARD_ACTION_MOVE_CARD'),
  },
  {
    key: ASSIGN,
    icon: changeAssigned,
    text: translate('DONOR_BOARD_ACTION_UPDATE_ASSIGNED'),
  },
  {
    key: EDIT,
    icon: editProfilePencil,
    text: translate('DONOR_BOARD_ACTION_EDIT_PROFILE'),
    shouldOpenDonor: true,
  },
  {
    key: REMOVE,
    icon: trashcanIcon,
    text: translate('DONOR_CARD_ACTION_REMOVE_CARD'),
  },
];

export { DONOR_ACTION_CONFIG };
